// extracted by mini-css-extract-plugin
module.exports = {"search":"Body_search__37x5M","hidden":"Body_hidden__6lGUL","body":"Body_body__w7ohu"};